import React from 'react';

import { Stack, Typography } from '@gogame/components';

import * as CONCEPT_FAMILY from 'scenes/Gallery/GalleryPage/ConceptFamilies/view-constants';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/view-constants';
import {
  AttributeItem,
  AttributeList,
} from 'scenes/Gallery/components/AttributeList';
import { PreviewFile } from 'scenes/Gallery/components/File';
import { THUMBNAIL_URL } from 'scenes/Gallery/components/File/constants';

const DetailsFile = ({ data }) => {
  const {
    [CONCEPT_FAMILY.ID]: conceptFamilyId,
    [CONCEPT_FAMILY.NAME]: conceptFamilyName,
    [CONCEPT_FAMILY.CONCEPTS_COUNT]: conceptsCount,
    [CONCEPT_FAMILY.CREATIVES_COUNT]: creativesCount,
    [CONCEPT_FAMILY.ORIGINAL]: original,
  } = data;

  const {
    [CREATIVE.FILE]: { [THUMBNAIL_URL]: originalFileThumbnailURL } = {},
  } = original || {};

  return (
    <Stack
      direction={'row'}
      alignItems={'center'}
      spacing={3}
      zeroMinWidth={true}
    >
      <PreviewFile src={originalFileThumbnailURL} width={132} height={70} />
      <Stack zeroMinWidth={true}>
        <Typography variant={'caption'} color={'textSecondary'}>
          {`Concept family #${conceptFamilyId}`}
        </Typography>
        <Stack spacing={1} direction={'row'}>
          <Typography variant={'h6'} noWrap={true}>
            {conceptFamilyName}
          </Typography>
        </Stack>
        <AttributeList type={'text'} listSeparator={'|'}>
          <AttributeItem valueParser={'conceptsCount'} value={conceptsCount} />
          <AttributeItem
            valueParser={'creativesCount'}
            value={creativesCount}
          />
        </AttributeList>
      </Stack>
    </Stack>
  );
};

export default DetailsFile;
